import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getRegistrations } from "../lib/firestoreContent";

const RegistrationList = () => {
  const [registrations, setRegistrations] = useState([]);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getRegistrations();
        setRegistrations(data);
        setCount(data.length);
      } catch (error) {
        console.error("Error fetching the data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="mt-28 md:mt-36 p-6 max-w-5xl mx-auto">
      <div className="mb-6 flex items-center justify-between">
        <Link
          to="/admin"
          className="text-primary hover:underline text-sm font-semibold inline-flex items-center gap-1.5"
        >
          ← Open Full Admin Dashboard
        </Link>
      </div>
      <h1 className="text-3xl font-bold mb-4 text-center">Registration List</h1>
      <h1 className="text-3xl font-bold mb-8 text-center">
        Number of Registered Participants:{" "}
        <span className="text-[red]">{count}</span>
      </h1>
      <ul className="space-y-8">
        {registrations
          .map((registration) => (
            <li
              key={registration.id || registration.email}
              className="border rounded-lg p-6 shadow-md bg-white"
            >
              <p className="text-lg">
                <strong className="font-semibold">Name:</strong>{" "}
                {registration.firstName} {registration.lastName}
              </p>
              <p className="text-lg">
                <strong className="font-semibold">Email:</strong>{" "}
                {registration.email}
              </p>
              <p className="text-lg">
                <strong className="font-semibold">Phone:</strong>{" "}
                {registration.phone}
              </p>
              <p className="text-lg">
                <strong className="font-semibold">
                  Preferred Learning Track:
                </strong>{" "}
                {registration.preferredLearningTrack}
              </p>
              <p className="text-lg">
                <strong className="font-semibold">Gender:</strong>{" "}
                {registration.gender}
              </p>
              <p className="text-lg">
                <strong className="font-semibold">Experience Level:</strong>{" "}
                {registration.experienceLevel}
              </p>
              <p className="text-lg">
                <strong className="font-semibold">
                  Motivation for Joining:
                </strong>{" "}
                {registration.motivationForJoining}
              </p>
              <p className="text-lg">
                <strong className="font-semibold">WhatsApp Number:</strong>{" "}
                {registration.whatsappNumber}
              </p>
              <p className="text-lg">
                <strong className="font-semibold">Availability:</strong>{" "}
                {registration.availability}
              </p>
              <p className="text-lg">
                <strong className="font-semibold">
                  Additional Information:
                </strong>{" "}
                {registration.additionalInformation || "N/A"}
              </p>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default RegistrationList;
